// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__37awJ","right":"Footer_right__22BZs","buttons":"Footer_buttons__3pmdT"};